/**
 * 判断是否countryCode
 * @param code
 * @returns
 */
export function isCountryCode (code: string): boolean {
  return /[A-Z]{2}/.test(code)
}
